import { Dimensions, PixelRatio } from "react-native";
const { width, height } = Dimensions.get("window");
const guidelineBaseWidth = 375;
const guidelineBaseHeight = 812;

const scale = (size) => (width / guidelineBaseWidth) * size;
const verticalScale = (size) => (height / guidelineBaseHeight) * size;
const moderateScale = (size, factor = 0.5) =>
  size + (scale(size) - size) * factor;

const vw = (w) => {
  // Parse string percentage input and convert it to number.
  const percent = (w / guidelineBaseWidth) * 100;
  const elemWidth = parseFloat(`${percent}%`);
  // Use PixelRatio.roundToNearestPixel method in order to round the layout
  // size (dp) to the nearest one that corresponds to an integer number of pixels.
  return PixelRatio.roundToNearestPixel((width * elemWidth) / 100);
};

const vh = (h) => {
  // Parse string percentage input and convert it to number.
  const percent = (h / guidelineBaseHeight) * 100;
  const elemHeight = parseFloat(`${percent}%`);

  // Use PixelRatio.roundToNearestPixel method in order to round the layout
  // size (dp) to the nearest one that corresponds to an integer number of pixels.
  return PixelRatio.roundToNearestPixel((height * elemHeight) / 100);
};

export { scale, verticalScale, moderateScale, vh, vw };
